import { VENTES_AVENUES } from '@/enums/retargeting'
import { generateRetargetingCookieName } from '@/utils/retargeting'
import { getCookieDomain } from '@/utils/cookie'
import { Middleware } from '@nuxt/types'
import { CookieDuration } from '@/enums/gtm'

const retargetingMiddleware: Middleware = ({ route, app }) => {
  const retargetingParam = route.query.ret

  if (retargetingParam === VENTES_AVENUES) {
    app.$cookies.set(generateRetargetingCookieName(VENTES_AVENUES), 'set', {
      expires: new Date(Date.now() + CookieDuration),
      path: '/',
      domain: getCookieDomain()
    })
  }
}

export default retargetingMiddleware
